export default __webpack_public_path__ + "static/media/must-edit.b9491050.svg";